import React from 'react';
import './App.scss';
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { TopNav } from './common/components/topNav/TopNav';
import AboutPage from './pages/aboutPage/Aboutpage';
import HelpPage from './pages/helpPage/HelpPage';
import SigninPage from './pages/signinPage/SigninPage';
import SignupPage from './pages/signupPage/SignupPage';
import FulfillPage from './pages/fulfillPage/FulfillPage';
import HomePage from './pages/homePage/HomePage';
import NewsPage from './pages/newsPage/NewsPage';
import Footer from './common/components/footer/Footer';

const TRACKING_ID = "G-YTECK3HL4R"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <Router basename='aggie-react-app'>
      <div className="App">
        <div id="topMainContainer">
          <TopNav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/news" element={<NewsPage />} />
            {/* <Route path="/help" element={<HelpPage />} /> */}
            <Route path="/signin" element={<SigninPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/fulfill" element={<FulfillPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>

  );
}

export default App;
